import { Turnstile } from "@marsidev/react-turnstile";
import { ReactNode, useState, useCallback, useMemo } from "react";

import { loadEnv } from "@smart/bridge-env-dom";

import { CaptchaContext, CaptchaContextType } from "./hooks";

export type CaptchaProviderProps = { children: ReactNode };

export const CaptchaProvider = ({ children }: CaptchaProviderProps) => {
  const [token, setToken] = useState<string | undefined>(undefined);
  const [isInitialised, setIsInitialised] = useState(false);

  const handleSuccess = useCallback((generatedToken: string) => {
    setToken(generatedToken);
    setIsInitialised(true);
  }, []);

  const handleError = useCallback((error: any) => {
    console.warn("Failed to obtain captcha token", error);
    setToken(undefined);
    setIsInitialised(true);
  }, []);

  const contextValue: CaptchaContextType = useMemo(
    () => ({
      token,
      setToken,
      isInitialised,
      siteKey: loadEnv("CloudflareCaptchaSiteKey"),
    }),
    [token, isInitialised],
  );

  return (
    <CaptchaContext.Provider value={contextValue}>
      <div className="hidden">
        <Turnstile
          id="captcha-hidden"
          siteKey={contextValue.siteKey}
          onSuccess={handleSuccess}
          onError={handleError}
          onBeforeInteractive={() => setIsInitialised(true)}
        />
      </div>
      {children}
    </CaptchaContext.Provider>
  );
};
